<template>
  <div class="track-item">
    <div class="track">
      <h3>{{ month }} {{ year }}</h3>
      <div
        :style="{ height, top }"
        class="track-line"/>
      <div
        v-for="(track, indexTrack) in tracks"
        :key="indexTrack"
        class="track-items">
        <div
          :class="{ 'disabled': profile.role === 'gerente_dealer' }"
          class="track-point"
          @click="checkComplete(track)">
          <div class="point"/>
          <div
            v-if="track.completed"
            class="complete"/>
        </div>
        <div class="date">
          {{ track.dueDate ? track.dueDate : track.createdAt | date('D MMM') }}
        </div>
        <div class="icon">
          <i :class="getTrackIcon(track.type)"/>
        </div>
        <div class="data">
          <div class="header">
            <h4 :class="{ 'complete': track.completed }">{{ getTrackTitle(track.type) }}</h4>
            <div>
              <span
                :class="{ 'success': track.status === 'Aceptada', 'danger': track.status === 'Rechazada', 'info': track.status === 'En Proceso' }"
                class="status">
                {{ track.status }}
              </span>
            </div>
            <div>
              <span
                :class="{ 'proposal': track.phase === 'PROPOSAL', 'negotiation': track.phase === 'NEGOTIATION', 'closing': track.phase === 'CLOSING_OF_SALE', 'product': track.phase === 'PRODUCT_DELIVERY' }"
                class="status">
                {{ parsePhase(track.phase) }}
              </span>
            </div>
            <div
              v-if="profile.role !== 'gerente_dealer' && track.edit"
              class="edit"
              @click="editTrack(track.id, (isFinal && indexTrack + 1 === tracks.length))">
              <i class="icon-edit"/>
            </div>
          </div>
        </div>
        <div/>
        <div/>
        <div/>
        <div>
          <p class="description">
            {{ track.title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
*
* TrackItem Component
*
* @author Emmanuel Hernández
* @copyright 2019, Marciano Studio S.C.
*/
export default {
  name: 'TrackItem',
  props: {
    month: {
      type: String,
      default: ''
    },
    year: {
      type: String,
      default: ''
    },
    tracks: {
      type: Array,
      default: () => {
        return []
      }
    },
    opportunity: {
      type: Object,
      default: () => ({})
    },
    isFinal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      top: 0,
      height: 0
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    this.calculateLine()
  },
  updated () {
    this.calculateLine()
  },
  methods: {
    editTrack (id, final) {
      this.$emit('editTrack', id, final)
    },
    calculateLine () {
      let points = this.$el.querySelectorAll('.track-point')
      if (points.length > 0) {
        this.top = `${points[0].offsetTop + 6}px`
        this.height = `${points[points.length - 1].offsetTop - points[0].offsetTop}px`
      }
    },
    getTrackTitle (val) {
      switch (val) {
        case 'VISIT':
          return 'Visita'
        case 'EMAIL':
          return 'Correo electrónico'
        case 'CALL':
          return 'Llamada'
        case 'QUOTATION':
          return 'Cotización'
        case 'DEMO':
          return 'Demo'
        case 'CREDIT':
          return 'Crédito'
        default:
          return val
      }
    },
    getTrackIcon (val) {
      switch (val) {
        case 'VISIT':
          return 'icon-map-pin'
        case 'EMAIL':
          return 'icon-mail'
        case 'CALL':
          return 'icon-phone-call'
        case 'QUOTATION':
          return 'icon-trending-up'
        case 'DEMO':
          return 'icon-image'
        case 'CREDIT':
          return 'icon-percent'
        default:
          return val
      }
    },
    checkComplete (track) {
      if (this.profile.role !== 'gerente_dealer') {
        this.$emit('checkComplete', track)
      }
    },
    parsePhase (phase) {
      switch (phase) {
        case 'PROPOSAL':
          return 'Propuesta'
        case 'NEGOTIATION':
          return 'Negociación'
        case 'CLOSING_OF_SALE':
          return 'Cierre de venta'
        case 'PRODUCT_DELIVERY':
          return 'Entrega de producto'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .track-item {
    + .track-item {
      margin-top: 20px;
    }
    .track {
      position: relative;
      h3 {
        font-family: Lato;
        font-size: 14px;
        color: #3E3E3E;
        font-weight: 400;
        margin: 0 0 15px 0;
        text-transform: capitalize;
      }
      .track-line {
        position: absolute;
        top: 0;
        left: 5.5px;
        width: 1px;
        background-color: #DDDDDD;
        height: 100px;
        z-index: -1;
      }
      .track-items {
        display: grid;
        grid-template-columns: 25px 60px 30px 1fr;
        row-gap: 10px;
        + .track-items {
          margin-top: 20px;
        }
        .track-point {
          padding: 0;
          align-self: center;
          cursor: pointer;
          position: relative;
          &.disabled {
            cursor: auto;
          }
          .point {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border: 2px solid #FF8206;
            background-color: #ffffff;
          }
          .complete {
            position: absolute;
            top: -2.5px;
            left: 1px;
            transform: translate(0, 0) rotate(-45deg);
            width: 14px;
            height: 6px;
            border-bottom: 2.3px solid #30B122;
            border-left: 2.3px solid #30B122;
            z-index: 50;
          }
        }
        .date {
          padding: 0;
          @include font-primary(13px, semibold);
          color: #3E3E3E;
          align-self: center;
        }
        .icon {
          padding: 0;
          font-size: 14px;
          align-self: center;
        }
        .data {
          .header {
            display: grid;
            grid-template-columns: 200px 90px 140px 1fr;
            align-items: center;
            h4 {
              @include font-primary(13px, regular);
              color: #3E3E3E;
              margin: 0;
              &.complete {
                text-decoration: line-through;
              }
            }
            .status {
              display: inline-block;
              padding: 3px 6px;
              border-radius: 3px;
              @include font-primary(11px, semibold);
              &.danger {
                border: 1px solid #f56c6c;
                color: #f56c6c;
              }
              &.success {
                border: 1px solid #30B122;
                color: #30B122;
              }
              &.info {
                border: 1px solid #409eff;
                color: #409eff;
              }
              &.proposal {
                border: 1px solid #409eff;
                color: #409eff;
              }
              &.negotiation {
                border: 1px solid #ffa142;
                color: #ffa142;
              }
              &.closing {
                border: 1px solid #ffd042;
                color: #ffd042;
              }
              &.product {
                border: 1px solid #30B122;
                color: #30B122;
              }
            }
            .edit {
              margin-left: 15px;
              cursor: pointer;
              color: #3E3E3E;
              i {
                font-size: 16px;
              }
            }
          }
        }
        .description {
            grid-area: description;
            @include font-primary(13px, regular);
            color: #707070;
            margin: 0;
          }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/trackings/track-item.vue